import { ActionType, Actions, ApplicationContextState } from '../applicationContext.types';
import { isAdminTeceo } from '../applicationContext.utils';

export const applicationContextStateInitialState: ApplicationContextState = {
  brand: undefined,
  brands: [],
  user: undefined,
  isAdminTeceo: isAdminTeceo(),
  isLoadingBrands: true,
  options: {
    showBrand: true,
    disableBrand: false,
  },
};

export const applicationContextReducer = (
  state: ApplicationContextState,
  action: ActionType,
): ApplicationContextState => {
  switch (action.type) {
    case Actions.LOADING_BRANDS: {
      return {
        ...state,
        isLoadingBrands: true,
      };
    }
    case Actions.SET_USER: {
      return {
        ...state,
        user: action.payload?.user,
      };
    }
    case Actions.SET_ADMIN_TECEO: {
      return {
        ...state,
        isAdminTeceo: true,
      };
    }
    case Actions.LOAD_CONTEXT: {
      return {
        ...state,
        ...action.payload,
        isLoadingBrands: false,
      };
    }
    case Actions.SET_BRAND: {
      return {
        ...state,
        brand: action.payload?.brand,
      };
    }
    case Actions.CONFIGURE_CONTEXT: {
      return {
        ...state,
        options: {
          ...state.options,
          ...action.payload?.options,
        },
      };
    }
    case Actions.HIDE_CONTACT_BRAND_FLOAT_BUTTON: {
      return {
        ...state,
        hideContactBrandButton: true,
      };
    }
    case Actions.RESET_CONTACT_BRAND_FLOAT_BUTTON_STATE: {
      return {
        ...state,
        hideContactBrandButton: false,
      };
    }
    default:
      console.error('Action in application context was not defined');
      return state;
  }
};
